import React from 'react';

import Thumb from '../img/blogs/react.jpg';

const TenThingsInReactThatWeShouldKnow = {
    id: 13, permalink: "10-things-in-react-that-we-should-know", thumb: Thumb, postBy: "Wasek Bellah", postDate: "May 07, 2020", categories: "ReactJS", title: "10 Things in React That We Should Know", shortDesc: "React is a declarative, efficient, and flexible JavaScript library for creating responsive user interfaces. It is maintained by Facebook.", fullDesc: <>
        <h2>Web Accessibility</h2>
        <p><strong>Web accessibility</strong> is the design of <strong>Web pages, tools, and technologies</strong> that everyone can use. Everyone here includes people with <strong>auditory, cognitive, neurological, physical, speech, and visual disabilities</strong>. <strong>Accessibility</strong> support is required to allow the interpretation of <strong>Web pages and applications</strong>.</p>

        <p><strong>Web development with accessibility</strong> ensures the total inclusion of the entire population that uses the <strong>Web</strong>.</p>

        <h3>Why Web Accessibility</h3>
        <p><strong>Web accessibility</strong> as a feature has been seen as a very wrong way of thinking about design because by default it excludes a large number of web users. For people who can't see or for some reason can't use a trackpad or mouse pointer, those people should get as many rights and access as possible.</p>

        <p>The included design starts with every web user thinking equally, it simply doesn’t show us <strong>Web accessibility</strong> as a feature.</p>


        <h2>Hyphen Cased Attributes in JSX</h2>
        <p>All <code>aria-*</code> <strong>HTML attributes</strong> are fully supported in <strong>JSX</strong>. In <strong>React</strong> most <strong>DOM</strong> properties and attributes are <strong>camelCased</strong>. But these attributes are <strong>hyphen-cased</strong> in <strong>React JSX</strong>.</p>

        <pre className="code">
            &lt;input type="text" aria-label=&#123;labelText&#125; aria-required="true" value=&#123;inputValue&#125; name="name" &#47;&gt;
        </pre>


        <h2>Semantic HTML</h2>
        <p><strong>Semantic HTML</strong> is the foundation of accessibility in a <strong>web application</strong>. Using a variety of <strong>HTML elements</strong> to strengthen the meaning of information on our websites often gives us free access.</p>

        <h4>Without Using Semantic HTML</h4>
        <pre className="code">
            return ( <br />
                &nbsp; &lt;div className="App"&gt; <br />
                    &nbsp;   &lt;div id="header"&gt;Header Area&lt;&#47;div&gt; <br />
                    &nbsp;   &lt;div id="main"&gt;Main Content Area&lt;&#47;div&gt; <br />
                    &nbsp;   &lt;div id="footer"&gt;Footer Area&lt;&#47;div&gt; <br />
                &nbsp; &lt;&#47;div&gt; <br />
            ); <br />
        </pre>

        <h4>Using Semantic HTML</h4>
        <pre className="code">
            return ( <br />
                &nbsp; &lt;div className="App"&gt; <br />
                    &nbsp;   &lt;header&gt;Header Area&lt;&#47;header&gt; <br />
                    &nbsp;   &lt;main&gt;Main Content Area&lt;&#47;main&gt; <br />
                    &nbsp;   &lt;footer&gt;Footer Area&lt;&#47;footer&gt; <br />
                &nbsp; &lt;&#47;div&gt; <br />
            ); <br />
        </pre>


        <h2>Accessible Forms Labeling</h2>
        <p><strong>As developers</strong> We should spend a good portion of our time <strong>building forms, adopting validation strategies, and ensuring consistency of submitted data</strong>.</p>

        <p>Each <strong>HTML</strong> form control, such as <code>&lt;input&gt;</code> and <code>&lt;textarea&gt;</code>, needs to be <strong>labeled accessible</strong>. We need to provide descriptive labels that are also open to screen readers.</p>

        <p>Although these standard <strong>HTML</strong> practices can be directly used in <strong>React</strong>, <strong>Note</strong> that the <code>for</code> attribute is written as <code>htmlFor</code> in <strong>JSX</strong></p>

        <pre className="code">
            &lt;label htmlFor="fullName"&gt;Full Name:&lt;&#47;label&gt; <br />
            &lt;input id="fullName" type="text" name="name" &#47;&gt;
        </pre>


        <h2>Higher-Order Components</h2>
        <p>A <strong>higher-order component (HOC)</strong> is a <strong>function</strong> that takes a <strong>component</strong> and returns a new <strong>component</strong>.</p>

        <p><strong>HOC</strong> is a pattern that is used to share common functionality between <strong>components</strong> without repeating the code. <strong>HOC</strong> is not actually a <strong>component</strong> even though it is a <strong>function</strong>. A <strong>HOC function</strong> takes a <strong>component</strong> as an argument and returns a <strong>component</strong>. It converts a <strong>component</strong> into another <strong>component</strong> and adds additional data or functionality.</p>

        <pre className="code">
            const NewComponent = (BaseComponent) => &#123; <br />
            &nbsp; &#47;&#47; ... create new component from old one and update <br />
            &nbsp; return UpdatedComponent <br />
            &#123;
        </pre>


        <h2>The Component Lifecycle</h2>
        <p><strong>Each component in React</strong> has several <strong>lifecycle methods</strong> that we can monitor and manipulate during its three main phases.</p>

        <p>The three phases are <strong>Mounting, Updating, and Unmounting</strong>.</p>

        <h3>Mounting</h3>
        <p><strong>Mounting</strong> means putting elements into the <strong>DOM</strong>.</p>
        <p><em><strong>React</strong> has four built-in methods that gets called, when <strong>mounting a component</strong></em>:</p>
        <ul>
            <li><code>constructor()</code></li>
            <li><code>getDerivedStateFromProps()</code></li>
            <li><code>render()</code></li>
            <li><code>componentDidMount()</code></li>
        </ul>

        <h3>Updating</h3>
        <p>The next stage of the <strong>lifecycle</strong> occurs when a <strong>component is updated</strong>.</p>

        <p>A <strong>component is updated</strong> whenever there is a change in the <strong>state or props of the component</strong>.</p>

        <p><em><strong>React</strong> has five built-in methods that gets called, when a <strong>component is updated</strong></em>:</p>
        <ul>
            <li><code>getDerivedStateFromProps()</code></li>
            <li><code>shouldComponentUpdate()</code></li>
            <li><code>render()</code></li>
            <li><code>getSnapshotBeforeUpdate()</code></li>
            <li><code>componentDidUpdate()</code></li>
        </ul>

        <h3>Unmounting</h3>
        <p>The next level of the <strong>lifecycle</strong> is when a <strong>component is removed from the DOM or unmounted</strong>.</p>

        <p><em><strong>React</strong> has only one built-in method that gets called when a <strong>component is unmounted</strong></em>:</p>
        <ul>
            <li><code>componentWillUnmount()</code></li>
        </ul>


        <h2>render()</h2>
        <p>The <code>render()</code> method is the only required method in a <strong>class component</strong>. This method is required and is the method that actually outputs <strong>HTML to the DOM.</strong></p>

        <pre className="code">
            class Header extends React.Component &#123; <br />
                &nbsp; render() &#123; <br />
                    &nbsp;   return &lt;h3&gt;This is the content of the Header component&lt;&#47;h3&gt;; <br />
                &nbsp; &#125; <br />
            &#125;
        </pre>
        <p><strong>Expected output:</strong> <code className="output">This is the content of the Header component</code></p>

        <p>The <code>render()</code> method should be pure, meaning it does not change or modify the <strong>component state</strong>, it returns the same result every time it's requested and does not interact directly with the browser.</p>


        <h2>constructor()</h2>
        <p>The <code>constructor()</code> method is called before anything else, when the <strong>component is initiated</strong>. It is the natural place to set up the initial <code>state</code> and other initial values.</p>

        <p>The <code>constructor()</code> method is called with the <code>props</code>, as arguments, and we should always start by calling the <code>super(props)</code> before anything else.</p>

        <pre className="code">
            class Header extends React.Component &#123; <br />
                &nbsp; constructor(props) &#123; <br />
                    &nbsp;   super(props); <br />
                    &nbsp;   this.state = &#123; favColor: "Blue" &#125;; <br />
                &nbsp; &#125; <br />
                &nbsp; render() &#123; <br />
                    &nbsp;   return &lt;h3&gt;My Favorite Color is &#123;this.state.favColor&#125;&lt;&#47;h3&gt;; <br />
                &nbsp; &#125; <br />
            &#125;
        </pre>
        <p><strong>Expected output:</strong> <code className="output">My Favorite Color is Blue</code></p>

        <p>This will initiate the <strong>parent's constructor</strong> method and allow the <strong>component</strong> to inherit the methods from its parent (<code>React.Component</code>).</p>


        <h2>componentDidMount()</h2>
        <p>The <code>componentDidMount()</code> method is called after the <strong>component is rendered or mounted</strong>.</p>

        <p>This is where we run statements that require that the <strong>component</strong> has already been placed in the <strong>DOM</strong>.</p>

        <pre className="code">
            class Header extends React.Component &#123; <br />
                &nbsp; constructor(props) &#123; <br />
                    &nbsp;   super(props); <br />
                    &nbsp;   this.state = &#123; favColor: "Blue" &#125;; <br />
                &nbsp; &#125; <br />
                &nbsp; componentDidMount() &#123; <br />
                    &nbsp;   setTimeout(() => &#123; <br />
                        &nbsp;     this.setState(&#123; favColor: "Green" &#125;); <br />
                    &nbsp;   &#125;, 5000); <br />
                &nbsp; &#125; <br />
                &nbsp; render() &#123; <br />
                    &nbsp;   return &lt;h3&gt;My Favorite Color is &#123;this.state.favColor&#125;&lt;&#47;h3&gt;; <br />
                &nbsp; &#125; <br />
            &#125;
        </pre>
        <p><strong>Expected output:</strong> <code className="output">My Favorite Color is Blue</code> after 5 seconds it will show: <code className="output">My Favorite Color is Green</code></p>


        <h2>componentDidUpdate()</h2>
        <p>The <code>componentDidUpdate()</code> method is called after the <strong>component</strong> is updated in the <strong>DOM</strong>.</p>

        <pre className="code">
            class Header extends React.Component &#123; <br />
                &nbsp; constructor(props) &#123; <br />
                    &nbsp;   super(props); <br />
                    &nbsp;   this.state = &#123; favColor: "Blue" &#125;; <br />
                &nbsp; &#125; <br />
                &nbsp; componentDidMount() &#123; <br />
                    &nbsp;   setTimeout(() => &#123; <br />
                        &nbsp;     this.setState(&#123; favColor: "Green" &#125;); <br />
                    &nbsp;   &#125;, 5000); <br />
                &nbsp; &#125; <br />
                &nbsp; componentDidUpdate() &#123; <br />
                    &nbsp;   document.getElementById("head4").innerHTML = "The updated favorite is " + this.state.favColor; <br />
                &nbsp; &#125; <br />
                &nbsp; render() &#123; <br />
                    &nbsp;   return ( <br />
                        &nbsp;     &lt;div&gt; <br />
                            &nbsp;       &lt;h3&gt;My Favorite Color is &#123;this.state.favColor&#125;&lt;&#47;h3&gt; <br />
                            &nbsp;       &lt;h4 id="head4"&gt;&lt;/h4&gt; <br />
                        &nbsp;     &lt;/div&gt; <br />
                    &nbsp;   ); <br />
                &nbsp; &#125; <br />
            &#125;
        </pre>
        <p><strong>Expected output:</strong> <code className="output">My Favorite Color is Blue</code>. After 5 seconds it will show: <code className="output">My Favorite Color is Green</code> and <code className="output">The updated favorite is Green</code></p>

        <p>When the <code>component</code> is <strong>mounting</strong> it is rendered with the favorite color <strong>"Blue"</strong>.</p>
        <p>When the <code>component</code> has been <strong>mounted</strong>, a timer changes the state, and the color becomes <strong>"Green"</strong>.</p>
    </>
};
export default TenThingsInReactThatWeShouldKnow;